import { t, type ErrorCodeMapperEntry } from "./types.js";

/** Error codes 42000-42999. One thousand-block per file: a duplicate number here can only
 *  collide within this file, which is what makes the split safer than one shared object. */
export const transmittalErrors = {
  // 42xxx transmittals. Two sites reused SPACE_NOT_FOUND (7015) and PROJECT_NOT_FOUND.
  TRANSMITTAL_NOT_FOUND: {
    errorCode: 42001,
    errorMessage: t("Transmittal not found"),
    isDynamic: false,
  },
  // Its own sentence ("User account not found") matches neither ACCOUNT_NOT_FOUND ("Account not
  // found") nor SESSION_USER_NOT_FOUND ("User not found"), so it keeps its own code.
  TRANSMITTAL_USER_ACCOUNT_NOT_FOUND: {
    errorCode: 42002,
    errorMessage: t("User account not found"),
    isDynamic: false,
  },
  TRANSMITTAL_CREATE_FAILED: {
    errorCode: 42003,
    errorMessage: t("Failed to create transmittal"),
    isDynamic: false,
  },
  TRANSMITTAL_FORM_TEMPLATE_MALFORMED: {
    errorCode: 42004,
    errorMessage: t(
      "The form template attached to this transmittal is not in the expected format.",
    ),
    isDynamic: false,
  },
  TRANSMITTAL_NO_FORM_TEMPLATE: {
    errorCode: 42005,
    errorMessage: t("This transmittal has no form template."),
    isDynamic: false,
  },
  TRANSMITTAL_CUSTOM_FIELDS_UPDATE_FAILED: {
    errorCode: 42006,
    errorMessage: t("Failed to update Custom Fields."),
    isDynamic: false,
  },
  TRANSMITTAL_SEND_NOT_ALLOWED_FROM_SPACE: {
    errorCode: 42007,
    errorMessage: t(
      "You do not have permission to send a transmittal from this Space.",
    ),
    isDynamic: false,
  },
  TRANSMITTAL_CONSUME_NOT_ALLOWED: {
    errorCode: 42008,
    errorMessage: t(
      "You do not have permission to consume files from this transmittal.",
    ),
    isDynamic: false,
  },
  TRANSMITTAL_SPACE_NOT_SPANNED: {
    errorCode: 42009,
    errorMessage: t(
      "This transmittal does not exist, or the Space is not one it spans.",
    ),
    isDynamic: false,
  },
} satisfies Record<string, ErrorCodeMapperEntry>;
